export default "__VITE_ASSET__DfjYeLkZ__"